import { useMemo } from "react";
import { useCurrentGamePicks } from "../use-current-game-picks.ts";
import { useCurrentScoringAndRank } from "../use-current-scoring-and-rank.ts";
import { getScoreByPlayer } from "./calculate-score.ts";

export function useCurrentScoreByPlayer() {
  const picksQuery = useCurrentGamePicks();
  const scoringQuery = useCurrentScoringAndRank();

  const scoreByPlayerId = useMemo(() => {
    if (picksQuery.data && scoringQuery.data) {
      const scoringEvents = scoringQuery.data.events;
      const picks = picksQuery.data;

      return getScoreByPlayer(scoringEvents, picks);
    }

    return {};
  }, [picksQuery.data, scoringQuery.data]);

  return {
    points: scoreByPlayerId,
    isPending: picksQuery.isPending || scoringQuery.isPending,
    isError: picksQuery.isError || scoringQuery.isError,
  };
}
